// bootstrap
import { Tooltip } from "react-bootstrap";

// TOOLTIPS
// delete
export const renderTooltipDelete = (props) => (
  <Tooltip {...props}>Delete Product</Tooltip>
);

// menu
export const renderTooltipMenu = (props) => <Tooltip {...props}>Menu</Tooltip>;


// help
export const renderTooltipHelp = (props) => <Tooltip {...props}>Help</Tooltip>;


// moreOptions
export const renderTooltipMoreOption = (props) => (
  <Tooltip {...props}>More Options</Tooltip>
);
